<template>
  <div class="activeLine">
    <div class="activeLine__inner">
      <img :src="require(`../assets/media/Content/Partners/${item}.png`)"
      v-for="(item, index) in list" :key="index" />
    </div>
    <div class="activeLine__inner">
      <img :src="require(`../assets/media/Content/Partners/${item}.png`)"
      v-for="(item, index) in list" :key="index" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PartnersLine',
  data() {
    return {
      list: [
        'me2on',
        'ghoststudio',
        'haechilabs',
        'havah',
        'miracle',
        'xpla',
        'neopin',
        'burrito',
        'normainmetaland',
        'dcent',
        'me2on',
        'ghoststudio',
        'haechilabs',
        'havah',
        'miracle',
        'xpla',
        'neopin',
        'burrito',
        'normainmetaland',
        'dcent',
      ],
    }
  }
}
</script>

<style>

</style>